import React, { useContext, useState, useEffect } from 'react';
import SearchContext from '../../state/context';

const CompareBar = props => {
  const {
    setExpanded,
    onCloseCommunity,
    compareBtnLabel,
    clearBtnLabel,
    shareBtnLabel,
    compareUrlPath = '/'
  } = props;
  const {
    responseData,
    expanded,
    comparedCommunities,
    onShareModalClick,
    onMapSwitcherClick,
    isMapActive
  } = useContext(SearchContext);

  const comparedCommunitiesLinks = () => {
    let uri = window.location.href;
    uri = uri.split('?')[0];
    const url = new URL(compareUrlPath);
    comparedCommunities.map((item, i) => {
      url.searchParams.set(`community${i + 1}`, item.raw.ssl_communityid);
    });

    return url.toString();
  };

  return (
    <div
      className={`find-a-community-map-view-row-headless__compare-section ${
        comparedCommunities.length > 0 && 'active'
      } ${comparedCommunities.length > 0 && expanded ? 'expanded' : ''}`}
    >
      <div className="find-a-community-map-view-row-headless__results-map-switcher">
        <div className="radio-tab-group">
          <div className="radio-tab">
            <button
              type="button"
              className={`${isMapActive ? 'radio-tab' : 'radio-tab--active'}`}
              onClick={() => {
                onMapSwitcherClick(false);
              }}
            >
              <span className="radio-tab__label">List View</span>
            </button>
          </div>
          <div className="radio-tab">
            <button
              type="button"
              className={`${isMapActive ? 'radio-tab--active' : 'radio-tab'}`}
              onClick={() => {
                onMapSwitcherClick(true);
              }}
            >
              <span className="radio-tab__label">Map View</span>
            </button>
          </div>
        </div>
      </div>
      <div className="find-a-community-map-view-row-headless__compare-bar-top">
        <h3 className="find-a-community-map-view-row-headless__compare-bar-heading">
          Compare Communities
        </h3>
        <button
          className="btn btn--primary find-a-community-map-view-row-headless__compare-bar-action"
          onClick={() => {
            setExpanded(!expanded);
          }}
        >
          <span className="btn__label">{expanded ? 'Collapse' : 'Expand'}</span>
          <svg width="18" height="11" role="presentation">
            <use xlinkHref="#arrow-down"></use>
          </svg>
        </button>
      </div>
      <div className="find-a-community-map-view-row-headless__compare-bar-content">
        <p className="find-a-community-map-view-row-headless__compare-bar-copy">
          Select up to 3 communities to get a side-by-side comparison.
        </p>
        <div className="find-a-community-map-view-row-headless__compare-communities">
          {comparedCommunities ? (
            comparedCommunities.map(community => (
              <div
                className="find-a-community-map-view-row-headless__compare-column"
                key={community.raw.ssl_communityid}
              >
                <div className="find-a-community-map-view-row__compare-column-image-container">
                  <button
                    className="find-a-community-map-view-row__image-close find-a-community-map-view-row__icon-btn"
                    aria-label="close"
                    onClick={e => {
                      onCloseCommunity(community);
                    }}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      role="presentation"
                    >
                      <use xlinkHref="#close"></use>
                    </svg>
                  </button>
                  <img
                    src={community.raw.ssl_thumbnailimage || community.raw.ssl_mainimagedesktop}
                    alt={community.raw.ssl_communityname}
                  />
                </div>
                <h4 className="find-a-community-map-view-row__compare-column-title">
                  {community.raw.ssl_communityname}
                </h4>
                <button
                  className="find-a-community-map-view-row__close--mobile find-a-community-map-view-row__icon-btn"
                  aria-label="close"
                  onClick={e => {
                    onCloseCommunity(community);
                  }}
                >
                  <svg width="24" height="24" role="presentation">
                    <use xlinkHref="#close"></use>
                  </svg>
                </button>
              </div>
            ))
          ) : (
            <></>
          )}
        </div>
        <div className="find-a-community-map-view-row-headless__compare-bar-buttons">
          <button
            className="btn btn--primary find-a-community-map-view-row-headless__compare-bar-button find-a-community-map-view-row-headless__compare-bar-share-btn"
            type="button"
            onClick={() => {
              const compareURL = comparedCommunitiesLinks();
              onShareModalClick(compareURL);
            }}
          >
            <svg width="25" height="25" role="presentation">
              <use xlinkHref="#share"></use>
            </svg>
            <span className="btn__label">{shareBtnLabel}</span>
          </button>
          <a
            href={comparedCommunitiesLinks()}
            className="btn btn--primary find-a-community-map-view-row-headless__compare-bar-button find-a-community-map-view-row-headless__compare-bar-compare-btn"
          >
            <span className="btn__label">{compareBtnLabel}</span>
          </a>
          <button
            className="btn btn--primary find-a-community-map-view-row__compare-bar-button find-a-community-map-view-row__compare-bar-clear-btn"
            type="button"
            onClick={e => {
              onCloseCommunity('all');
            }}
          >
            <span className="btn__label">{clearBtnLabel}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
